import React, { Component } from 'react';

class Input extends Component {
    constructor(props) {
        super(props);
        this.state = {
            focus: false,
            blur: false,
        }
    }

    getBorderColor = () => {
        if (this.state.focus) {
            return window.color['searchBoxBgColor'];
        }
        if (this.state.blur) {
            /*if (this.props.validation === 'email' && !(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.props.value))) {
                return 'red';
            }
            if (this.props.validation === 'mobile' && (this.props.value + '').length !== 10) {
                return 'red';
            }*/
            if (!this.props.value || this.props.value === '') {
                return 'red';
            }
        }
        if (this.props.value === '') {
            return 'red';
        }
        return '#838383';
    }

    render() {
        return (
            <div style={{ ...this.props.style, position: 'relative', padding: '15px 0' }}>
                <input
                    type={this.props.type}
                    value={this.props.value}
                    onFocus={() => this.setState({ focus: true, blur: false })}
                    onBlur={() => this.setState({ focus: false, blur: true })}
                    onChange={this.props.handleChange}
                    name={this.props.name}
                    maxLength={this.props.max}
                    readOnly={this.props.isReadyOnly}
                    //autoFocus = { this.props.tab === 1 }
                    className={`${this.props.className} ${this.state.focus  ? 'txtActive':'txtInactive'}`}
                    style={{
                        background: 'transparent',
                        border: 0,
                        outline: 0,
                        width: '100%',
                        padding: 0,
                        color: '#444',
                        fontWeight: '300',
                        borderBottom: '1px solid',
                        borderColor: this.getBorderColor(),
                        transition: '0.3s ease',
                        fontSize: '1rem'
                    }}

                />
                <label style={{
                    position: 'absolute',
                    left: this.props.isImg ? '40px' : '0',
                    fontSize: this.state.focus || (this.props.value + '').length > 0 ? '0.8rem' : 'inherit',
                    bottom: this.state.focus || (this.props.value + '').length > 0 ? '40px' : '20px',
                    transition: '0.3s ease',
                    pointerEvents: 'none',
                    color: this.getBorderColor()
                }}

                    className={this.state.focus || (this.props.value + '').length > 0 ? 'lblActive' : 'lblInactive'}
                >
                    {this.props.placeholder}
                </label>
            </div>
        )
    }
}

export default Input;


// WEBPACK FOOTER //
// ./src/components/common/input.js